import { Map } from 'immutable';
import { combineReducers } from 'redux-immutable'
import eventsReducer from './eventsReducer';
import settingsReducer from './settingsReducer';
import configReducer from './configReducer';

const INIT_STATE = Map();

const combinedReducer = combineReducers({
    settings: settingsReducer,
    events: eventsReducer,
    config: configReducer,
});

const eventDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default eventDataReducer;